import { Box, IconButton } from "@mui/material";
import type { SxProps, Theme } from "@mui/system";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext } from "react";

import { trackEvent } from "utils/tracking";

export default function TemplateEditButton({
  templateId,
  sx,
}: {
  templateId: number;
  sx?: SxProps<Theme>;
}) {
  const { setEditTemplateDialogId } = useContext(OutreachTemplatesContext);

  return (
    <IconButton
      onClick={() => {
        trackEvent("Edit Template Button Clicked", {
          "Template Id": templateId,
        });
        setEditTemplateDialogId(templateId.toString());
      }}
      sx={sx || { width: 30, height: 30 }}
      size="small"
    >
      <Box
        component="i"
        sx={{ color: "primary.main", fontSize: 14 }}
        className="fa-solid fa-edit"
      />
    </IconButton>
  );
}
